export default {
    name: 'warehouseLocationsPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'warehouseLocations';
        const route = app.routes.getItem(routeName);
        if (route) {
            route.loader = () => import('./packages/WarehouseLocations/core');

            app.routes.changeItem(routeName, route);
        }
    },
};
